import CoreAPIService from './CoreAPIService';

class HomeService {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }

    async getGalleryList(data) {
        return this.apiService.get('/gallery', { ...data });
    }

    async getGalleryDetails(id) {
        return this.apiService.get(`/gallery/${id}`);
    }

    async submitContactForm(data) {
        return this.apiService.post('/counseling/regist', { ...data });
    }

}

export default new HomeService();
